<template>
    <b-modal
        id="modal-quick-content"
        :visible="value"
        title="Hızlı İçerik Ekle"
        size="lg"
        no-close-on-backdrop
        @hidden="$emit('input', false)"
    >
        <b-form @submit.prevent="save">
            <b-form-group label="Kategori *">
                <v-select
                    v-model="form.categoryId"
                    :options="categories"
                    :reduce="cat => cat.Id"
                    label="CategoryName"
                    placeholder="Kategori Seçin"
                />
            </b-form-group>

            <b-row>
                <b-col md="6">
                    <b-form-group label="Content Key *">
                        <b-form-input v-model="form.contentKey" placeholder="unique-key" />
                    </b-form-group>
                </b-col>
                <b-col md="6">
                    <b-form-group label="Slug *">
                        <b-form-input v-model="form.slug" placeholder="url-slug" />
                    </b-form-group>
                </b-col>
            </b-row>

            <b-tabs pills>
                <b-tab
                    v-for="lang in languages"
                    :key="lang.LanguageCode"
                    :title="lang.LanguageName"
                >
                    <b-form-group label="Başlık" class="mt-2">
                        <b-form-input
                            v-model="getTranslation(lang.LanguageCode).Title"
                            placeholder="İçerik Başlığı"
                        />
                    </b-form-group>

                    <b-form-group label="Özet">
                        <b-form-textarea
                            v-model="getTranslation(lang.LanguageCode).Summary"
                            rows="3"
                            placeholder="Kısa açıklama"
                        />
                    </b-form-group>
                </b-tab>
            </b-tabs>

            <b-row>
                <b-col md="6">
                    <b-form-checkbox v-model="form.isActive" switch>
                        Aktif
                    </b-form-checkbox>
                </b-col>
                <b-col md="6">
                    <b-form-checkbox v-model="form.isFeatured" switch>
                        Öne Çıkan
                    </b-form-checkbox>
                </b-col>
            </b-row>
        </b-form>

        <template #modal-footer>
            <b-button variant="secondary" @click="$emit('input', false)">
                İptal
            </b-button>
            <b-button variant="primary" :disabled="loading" @click="save">
                <b-spinner v-if="loading" small class="mr-50" />
                Kaydet
            </b-button>
        </template>
    </b-modal>
</template>

<script>
import { BModal, BForm, BFormGroup, BFormInput, BFormTextarea, BFormCheckbox, BButton, BRow, BCol, BTabs, BTab, BSpinner } from 'bootstrap-vue';
import vSelect from 'vue-select';
import WebsiteApi from '@/api/website';

export default {
    name: 'QuickContentModal',
    components: {
        BModal, BForm, BFormGroup, BFormInput, BFormTextarea, BFormCheckbox,
        BButton, BRow, BCol, BTabs, BTab, BSpinner, vSelect
    },
    props: {
        value: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            loading: false,
            categories: [],
            languages: [],
            form: {
                categoryId: null,
                contentKey: '',
                slug: '',
                isActive: true,
                isFeatured: false,
                publishDate: new Date().toISOString(),
                sortOrder: 0,
                translations: []
            }
        };
    },
    watch: {
        value(val) {
            if (val) {
                this.loadData();
            }
        }
    },
    methods: {
        async loadData() {
            try {
                const [categoriesRes, languagesRes] = await Promise.all([
                    WebsiteApi.Category.GetAll(),
                    WebsiteApi.Language.GetAll()
                ]);

                if (categoriesRes.data.Success) {
                    this.categories = categoriesRes.data.Data;
                }
                if (languagesRes.data.Success) {
                    this.languages = languagesRes.data.Data;
                    this.initializeTranslations();
                }
            } catch (error) {
                console.error('Data yüklenemedi:', error);
            }
        },

        initializeTranslations() {
            this.form.translations = this.languages.map(lang => ({
                LanguageCode: lang.LanguageCode,
                Title: '',
                Summary: '',
                Content: '',
                SeoTitle: '',
                SeoDescription: ''
            }));
        },

        getTranslation(languageCode) {
            let translation = this.form.translations.find(t => t.LanguageCode === languageCode);
            if (!translation) {
                translation = {
                    LanguageCode: languageCode,
                    Title: '',
                    Summary: '',
                    Content: ''
                };
                this.form.translations.push(translation);
            }
            return translation;
        },

        async save() {
            if (!this.form.categoryId || !this.form.contentKey || !this.form.slug) {
                this.$toast.warning('Lütfen zorunlu alanları doldurun!');
                return;
            }

            this.loading = true;
            try {
                const payload = {
                    CategoryId: this.form.categoryId,
                    ContentKey: this.form.contentKey,
                    Slug: this.form.slug,
                    IsActive: this.form.isActive,
                    IsFeatured: this.form.isFeatured,
                    PublishDate: this.form.publishDate,
                    SortOrder: this.form.sortOrder,
                    Translations: this.form.translations,
                    MetaData: [],
                    MediaFiles: []
                };

                const response = await WebsiteApi.Content.Create(payload);
                this.$result(response);

                if (response.data.Success) {
                    this.$emit('saved');
                    this.$emit('input', false);
                }
            } catch (error) {
                this.$result(null, error);
            } finally {
                this.loading = false;
            }
        }
    }
};
</script>